import { api } from './client.ts';
import type { AiDisclosureProvider } from '@shared/ai-disclosure.ts';

export interface AiDisclosure {
  version: string;
  accepted: boolean;
  acceptedAt: string | null;
  providers: AiDisclosureProvider[];
}

export const aiDisclosureApi = {
  get: () => api.get<AiDisclosure>('/me/ai-disclosure'),
  accept: (version: string) => api.post<AiDisclosure>('/me/ai-disclosure', { version }),
};
